import React from "react";

import Header from "../components/shared/Header";
import Footer from "../components/shared/Footer";

interface MainLayoutProps {
  children: React.ReactNode;
  className?: string;
}

function cn(...classes: (string | undefined)[]) {
  return classes.filter(Boolean).join(" ");
}

export function MainLayout({ children, className }: MainLayoutProps) {
  return (
    <div className="sticky-footer-layout">
      <Header />
      {/* Main Content */}
      <main className={cn("sticky-footer-main", className)}>{children}</main>
      <Footer />
    </div>
  );
}
